<template>
  <div class="page">
    <Header></Header>
    <div class="scroll">
    <div class="body" :style="bannerStyle">
      <div :style="bannerHeightStyle"></div>

      <div class="box">
        <div class="main-title">生而有光，渐入JIA境</div>
        <div class="sub-title">汽车之家2027届JIA STAR家速计划校招Q&A</div>
        <div class="content">
          <div class="qa-title">1、什么是JIA STAR家速计划？</div>
          <p>JIA STAR家速计划是汽车之家面向全球优秀应届毕业生打造的<span style="color:#FF6600">新生代精英成长项目</span>。项目聚焦吸纳心怀热忱、善于创新、勇于担当的青年新锐，依托平台完整的汽车生态、海量真实业务场景与专属加速培养体系，助力应届生快速完成能力迭代、进阶突破，实现加速成长、渐入佳境，是汽车之家孵化青年骨干、储备核心新生力量的专属校园招聘品牌。</p>
          <p>
            <span class="letter" style="color:#FF6600">J</span> ‑ Joyful 怀热忱｜保有内在热爱与自驱，源于本心，投入工作<br/>
            <span class="letter" style="color:#FF6600">I</span> ‑ Innovative 善创思｜不困于既有经验，敢于打破固有定式<br/>
            <span class="letter" style="color:#FF6600">A</span> ‑ Accountable 有担当｜秉持主人翁意识，严谨落地、闭环交付
          </p>
          <div class="qa-title">2、本次校招面向的群体是？毕业时间如何界定？</div>
          <p>2027届JIA STAR家速计划面向海内外的优秀应届毕业生：</p>
          <p>中国大陆地区：<span style="color:#FF6600">2026年9月1日—2027年8月31日</span>毕业</p>
          <p>非中国大陆地区：<span style="color:#FF6600">2026年1月1日—2027年12月31日</span>毕业</p>
          <p>（中国大陆地区以毕业证为准，非中国大陆地区以留服认证为准，且最高学历毕业后无全职工作经历）</p>

          <div class="qa-title">3、校招时间安排是什么样的？</div>
          <p><span style="color:#FF6600">简历投递时间：</span>越早投递简历，被发起面试和能拿到offer的机会越大，大部分岗位会集中在10-11月完成面试和录用。强烈建议同学们在9月进行投递，以免错失机会。</p>
          <p><span style="color:#FF6600">面试时间安排：</span>校招面试将于10月份陆续启动，投递后请耐心等待并专注筛选状态；根据各岗位招聘情况面试将持续安排，请及时关注邮箱及电话通知。</p>
          <p><span style="color:#FF6600">Offer发放：</span>所有面试通过后1周左右将进行offer沟通及发放，请保持联系方式畅通。</p>

          <div class="qa-title">4、招聘对学历及专业有限制吗？</div>
          <p>本次校招面向<span style="color:#FF6600">全日制本科及以上</span>的同学开放，具体岗位略有不同，请根据职位介绍选择自己的心仪岗位进行投递；大部分岗位无严格专业限制，欢迎不同学科背景的优秀同学投递。你可以在具体职位描述中查看岗位的详细要求。</p>

          <div class="qa-title">5、本届校招每人可以投递几个职位？</div>
          <p>每人仅可投递<span style="color:#FF6600">1个</span>职位，请同学们看好职位介绍谨慎选择哦！</p>

          <div class="qa-title">6、可以进行内推吗？</div>
          <p>我们鼓励员工积极参与内推，内推简历会被<span style="color:#FF6600">优先筛选</span>。本次秋招内推仅支持通过在职员工分享的职位链接进行投递，请在选好投递职位后，找到在职的汽车之家小伙伴获取内推职位链接完成投递；或者直接把简历给到内推人，他们可以上传至内推系统。</p>

          <div class="qa-title">7、如何投递简历？</div>
          <p>一共有两种投递方式：</p>
          <p>渠道一：<span style="color:#FF6600">官网投递</span>。登录"汽车之家校园招聘"官网进行投递，官网地址：<a style="color:#FF6600" href="https://talent.autohome.com.cn/campus_index.html" target="_blank">https://talent.autohome.com.cn/campus_index.html</a></p>
          <p>渠道二：<span style="color:#FF6600">微信公众号</span>。微信搜索"汽车之家招聘"，关注公众号后进入"校园招聘"进行投递。</p>

          <div class="qa-title">8、如何查询我的招聘进展？</div>
          <p>进入<span style="color:#FF6600">"汽车之家招聘"</span>微信公众号，点击校园招聘里的应聘记录可查看；或登录<span style="color:#FF6600">"汽车之家校园招聘"</span>官网，点击屏幕右上角的<span style="color:#FF6600">"个人姓名"</span>后即可查看。</p>
          <div class="qa-title">9、面试预计会有几轮？会是什么形式？</div>
          <p>面试共有<span style="color:#FF6600">三轮</span>，分别为专业一面、专业二面及HR面，均为<span style="color:#FF6600">线上面试</span>。</p>
          <div class="qa-title">10、如有问题，如何联系HR？</div>
          <p>如有问题可通过校招官方邮箱与我们取得联系：<a style="color:#FF6600" href="mailto:campus@autohome.com.cn">campus@autohome.com.cn</a></p>
        </div>
      </div>

    </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header1";
import Footer from "./Footer";
import Utils from "../utils/Utils";

export default {
  name: "QA",
  components:{
    Header,
    Footer
  },
  data() {
    return {
      app:"",
      bannerStyle:"background-image: url('https://www2.autoimg.cn/oadfs/g33/M09/07/4A/ChxpVmqg93mADEkkABnpAItLfes190.jpg');",
      bannerHeightStyle:"height: 103px;",
    };
  },
  mounted: function() {
    this.app = Utils.getApp();
    this.getBannerHeight();
    this._resizeHandler = () => {
      setTimeout(() => {
        this.getBannerHeight();
      }, 10)
    };
    window.addEventListener('resize', this._resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._resizeHandler);
  },
  methods: {
    getBannerHeight() {
      let width = window.innerWidth;
      let height = width / (375.0 / 103);
      this.bannerHeightStyle = "height: " + height + "px;";
    },
  },
}
</script>

<style scoped>
  .page{
    height: 100%;
    flex-direction: column;
    display: flex;
    background-color: #F5F7FA;
  }
  .scroll{
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background-color: #F5F7FA;
  }
  .body{
    background-repeat: no-repeat;
    background-size: contain;
  }
  .box{
    margin-top: 16px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 20px 16px;
    background: #FFFFFF;
    border-radius: 6px;
  }
  .main-title{
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #20253F;
    text-align: center;
    font-weight: 600;
    line-height: 28px;
  }
  .sub-title{
    font-size: 14px;
    color: #FF6600;
    text-align: center;
    font-weight: 600;
    margin-top: 6px;
    margin-bottom: 20px;
  }
  .title{
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #20253F;
    text-align: center;
    font-weight: 500;
  }
  .title-line{
    width: 16px;
    height: 3px;
    background: #0055FF;
  }
  .content{
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #20253F;
    line-height: 17px;
    font-weight: 400;
  }
  .content p{
    margin: 0;
    padding: 0;
  }
  .qa-title{
    margin-top: 20px;
    margin-bottom: 8px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #20253F;
    font-weight: 500;
  }
  .letter{
    display: inline-block;
    width: 12px;
    text-align: center;
  }
</style>
